import { getCertificateList, getMyCertificates, addCertificate, updateCertificate, deleteCertificate, uploadCertificate, getCertificateById } from "@/services/certificate.service";
import { setPaginationDetails } from "@/utils/utils";
import { formatDateEdit } from "@/utils/utils";

// initial state
const state = () => ({
  certificateModel: {
    levels: {
      description: "",
    },
    studentName: "",
    studentSurname: "",
    studentNo: 0,
    certificateNo: 0,
    studentBirthPlace: "",
    examLocation: "",
    studentBirthDate: null,
    examDate: null,
    studentNationality: "",
    studentExamScore: "",
  },
});

// mutations
const mutations = {
  setCertificateModel(state, data) {
    state.certificateModel = data;
  },
};

// actions
const actions = {
  //Sertifika Listesi
  async loadCertificateList(vuexContext, co) {
    return await getCertificateList(co).then((response) => {

      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((student) => {
        student.certificateStudentFullname = `${student.name} ${student.lastname}`;
        //student.level = student.classStatusMulti?.classStatus ? student.classStatusMulti?.classStatus?.levels?.description : student.levels.description;
        student.level = student.levelDescription;
        student.studentNo = student.userStudentId ? student.userStudentId : student.studentNo;
        student.nationalityId = student.nationalitysId;
        //student.levelsId = student.levelsId ; //? student.levelsId : student.classStatusMulti?.classStatus?.levelsId;
        student.birthDate = formatDateEdit(student.birthDate);
        student.examDate = formatDateEdit(student.examDate);
      });

      setPaginationDetails(co, totalCount, totalPages);
      // console.log(items);
      return items;
    });
  },

  async loadMyCertificates() {
    return await getMyCertificates().then((response) => {

      let data = response.data.data;
      let items = data.items;

      items.map((student) => {
        student.certificateStudentFullname = `${student.name} ${student.lastname}`;
        student.level = student.levelDescription;
        student.studentNo = student.userStudentId ? student.userStudentId : student.studentNo;
        student.nationalityId = student.nationalitysId;
        student.birthDate = formatDateEdit(student.birthDate);
        student.examDate = formatDateEdit(student.examDate);
      });

      return items;
    });
  },

  async getCertificateById(vuexContext, id) {
    return await getCertificateById(id).then((response) => {
      //console.log(response);
      let data = response.data.data;
      return data;
    })
  },

  async postCertificate(vuexContext, certificate) {
    certificate.studentNo = 0;
    return await addCertificate(certificate).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async updateCertificate(vuexContext, certificate) {
    certificate.active = true;
    return await updateCertificate(certificate).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async deleteCertificate(vuexContext, certificate) {
    return await deleteCertificate(certificate).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async uploadCertificate(vuexContext, certificateFile) {
    return await uploadCertificate(certificateFile).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  addCertificateModel(vuexContext, data) {
    vuexContext.commit("setCertificateModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
